import { CompanyType } from "@/Enums/CompanyType";
import { companyType } from "@/Utils/environment";

const KOOPERATIVA_LOGO_SRC =
    "data:image/svg+xml,%3csvg%20width='56'%20height='48'%20viewBox='0%200%2056%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M36.381%2036.9558H19.6193L28.0001%2022.2647L36.381%2036.9558ZM24.6296%2016.3335C20.2569%2017.3373%2016.522%2020.0747%2014.2446%2023.9984L0.580078%2047.9969H13.2425L16.2487%2042.7957C19.2549%2046.1719%2023.5364%2048.0881%2028.0001%2047.9969H55.4202L49.0434%2036.8645H43.0311C44.3975%2032.5758%2043.942%2027.9221%2041.6646%2023.9984V23.9072L28.0001%200L21.6234%2011.1324L24.6296%2016.3335Z'%20fill='%23E20714'/%3e%3c/svg%3e";

const KOMUNALNA_LOGO_SRC = "https://static.kpas.sk/pics/komunalna-logo-only.svg";

export type LogoOnlyProps = {
    width: number | string;
    height?: number | string;
};

const getLogoOnlySrc = (): string => {
    switch (companyType) {
        case CompanyType.KOMUNALNA:
            return KOMUNALNA_LOGO_SRC;
        case CompanyType.KOOPERATIVA:
        default:
            return KOOPERATIVA_LOGO_SRC;
    }
};

const getLogoOnlyAlt = (): string => {
    switch (companyType) {
        case CompanyType.KOMUNALNA:
            return "Komunálna poisťovňa";
        case CompanyType.KOOPERATIVA:
        default:
            return "Kooperativa";
    }
};

export const LogoOnly = ({ width, height = "auto" }: LogoOnlyProps) => (
    <img
        src={getLogoOnlySrc()}
        alt={getLogoOnlyAlt()}
        width={width}
        height={height}
    />
);
